/** One-time mission-briefing screen shown before the camera/audio ever engage. */
export class IntroPanel {
  private readonly root = this.getElement('#intro-panel');

  constructor(onStart: () => void) {
    this.getElement('#intro-start').addEventListener('click', () => {
      this.hide();
      onStart();
    });
  }

  hide(): void {
    this.root.hidden = true;
  }

  private getElement(selector: string): HTMLElement {
    const element = document.querySelector<HTMLElement>(selector);
    if (!element) throw new Error(`Missing element: ${selector}`);
    return element;
  }
}
